module.exports = __webpack_public_path__ + "img/mouse-square.5cc9d696.svg";